var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mun-wrap" },
    [
      _c(
        "div",
        { staticClass: "textarea-wrap" },
        [
          !_vm.onlyShow
            ? _c(
                "div",
                { staticClass: "top-wrap" },
                [
                  _c("span", { staticClass: "margin18" }, [_vm._v("插入:")]),
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "top-start",
                        width: "600",
                        "popper-class": "my-pop el-popover-index",
                        trigger: "click"
                      }
                    },
                    [
                      _c(
                        "div",
                        _vm._l(_vm.emojiList, function(item, index) {
                          return _c(
                            "button",
                            {
                              key: index,
                              staticClass: "emoji",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.insertHtmlAtCaret(item)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(item) + " ")]
                          )
                        }),
                        0
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "margin18 set-color",
                          attrs: { slot: "reference" },
                          slot: "reference"
                        },
                        [_vm._v("表情")]
                      )
                    ]
                  ),
                  _vm.myType == 1 || _vm.myType == 2
                    ? _c(
                        "span",
                        {
                          staticClass: "margin18 set-color",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.insertHtmlAtCaret("{cusName}")
                            }
                          }
                        },
                        [_vm._v("客户昵称")]
                      )
                    : _vm._e(),
                  _vm.myType == 1 || _vm.myType == 2 || _vm.myType == 3
                    ? _c(
                        "span",
                        {
                          staticClass: "margin18 set-color",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.insertHtmlAtCaret("{empName}")
                            }
                          }
                        },
                        [_vm._v("员工姓名")]
                      )
                    : _vm._e(),
                  _vm.myType == 4
                    ? _c(
                        "span",
                        {
                          staticClass: "margin18 set-color",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.addWelcomeHandle.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v("欢迎语模板")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c("el-input", {
            ref: "myTextarea",
            attrs: {
              disabled: _vm.onlyShow,
              type: "textarea",
              id: "myTextarea" + _vm.myType,
              clearable: "",
              autocomplete: "off",
              placeholder: _vm.placeholder,
              size: "small",
              maxlength: _vm.myType == 6 ? 500 : 200,
              "show-word-limit": ""
            },
            on: { focus: _vm.focusHandler, blur: _vm.inputBlur },
            nativeOn: {
              click: function($event) {
                return _vm.focusHandler.apply(null, arguments)
              },
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ]) &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ]) &&
                  _vm._k($event.keyCode, "left", 37, $event.key, [
                    "Left",
                    "ArrowLeft"
                  ]) &&
                  _vm._k($event.keyCode, "right", 39, $event.key, [
                    "Right",
                    "ArrowRight"
                  ])
                ) {
                  return null
                }
                if ("button" in $event && $event.button !== 0) {
                  return null
                }
                if ("button" in $event && $event.button !== 2) {
                  return null
                }
                return _vm.focusHandler.apply(null, arguments)
              },
              select: function($event) {
                return _vm.selectHandler.apply(null, arguments)
              },
              input: function($event) {
                return _vm.onInput($event)
              }
            },
            model: {
              value: _vm.content,
              callback: function($$v) {
                _vm.content = $$v
              },
              expression: "content"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "upload-wrap" }, [
        !_vm.onlyShow
          ? _c(
              "div",
              { staticClass: "btn-wrap" },
              [
                _c(
                  "el-upload",
                  {
                    ref: "uploadPhotoItem",
                    staticClass: "upload-demo",
                    attrs: {
                      action: _vm.sendUrl,
                      headers: _vm.headers,
                      data: _vm.sendParams,
                      "show-file-list": false,
                      accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PBG,",
                      "before-upload": _vm.beforeUploadPhoto,
                      limit: 9,
                      multiple: true,
                      "on-exceed": _vm.exceed,
                      "on-success": _vm.handleSuccess,
                      "on-error": _vm.onError,
                      disabled: _vm.handleBtnStatus("img")
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          slot: "trigger",
                          size: "small",
                          title: "图片大小不超过2M，格式为.jpg、.png",
                          icon: "el-icon-plus",
                          type: "primary",
                          plain: "",
                          disabled: _vm.handleBtnStatus("img")
                        },
                        slot: "trigger"
                      },
                      [_vm._v("添加图片")]
                    )
                  ],
                  1
                ),
                _vm.myType != 5
                  ? _c(
                      "el-button",
                      {
                        staticClass: "upload-demo",
                        attrs: {
                          slot: "trigger",
                          size: "small",
                          icon: "el-icon-plus",
                          type: "primary",
                          plain: "",
                          disabled: _vm.handleBtnStatus("link")
                        },
                        on: { click: _vm.showNewLink },
                        slot: "trigger"
                      },
                      [_vm._v("插入链接")]
                    )
                  : _vm._e(),
                _vm.myType != 4 && _vm.myType != 6
                  ? _c(
                      "el-button",
                      {
                        staticClass: "upload-demo",
                        attrs: {
                          slot: "trigger",
                          size: "small",
                          icon: "el-icon-plus",
                          type: "primary",
                          plain: "",
                          disabled: _vm.handleBtnStatus("product")
                        },
                        on: { click: _vm.showProduct },
                        slot: "trigger"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.currentSysm != 2 && _vm.currentSysm != 3
                              ? "插入商品/券"
                              : "插入商品"
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.myType == 7
                  ? _c(
                      "el-upload",
                      {
                        ref: "uploadVideoItem",
                        staticClass: "upload-demo",
                        attrs: {
                          action: _vm.sendUrl,
                          headers: _vm.headers,
                          data: _vm.sendParams,
                          "show-file-list": false,
                          accept: ".MP4,.mp4",
                          limit: 1,
                          "on-exceed": _vm.exceed2,
                          "before-upload": _vm.beforeUploadVideo,
                          "on-success": _vm.handleVideoSuccess,
                          "on-error": _vm.onError,
                          disabled: _vm.handleBtnStatus("video")
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "trigger",
                              size: "small",
                              title: "视频大小不超过10M，格式为.mp4",
                              icon: "el-icon-plus",
                              type: "primary",
                              plain: "",
                              disabled: _vm.handleBtnStatus("video")
                            },
                            slot: "trigger"
                          },
                          [_vm._v("添加视频")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.myType == 7
                  ? _c(
                      "el-upload",
                      {
                        ref: "uploadFileItem",
                        staticClass: "upload-demo",
                        attrs: {
                          action: _vm.sendUrl,
                          headers: _vm.headers,
                          data: _vm.sendParams,
                          "show-file-list": false,
                          accept: ".doc,.xlsx,.xls,.ppt,.pdf",
                          limit: 1,
                          "on-exceed": _vm.exceed3,
                          "before-upload": _vm.beforeUploadFile,
                          "on-success": _vm.handleFileSuccess,
                          "on-error": _vm.onError,
                          disabled: _vm.handleBtnStatus("file")
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "trigger",
                              title:
                                "文档大小不超过10M，格式为.doc、.xlsx、.xls、.ppt、.pdf",
                              size: "small",
                              icon: "el-icon-plus",
                              type: "primary",
                              plain: "",
                              disabled: _vm.handleBtnStatus("file")
                            },
                            slot: "trigger"
                          },
                          [_vm._v("上传文档")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.myType == 5
                  ? _c(
                      "el-button",
                      {
                        staticClass: "upload-demo",
                        attrs: {
                          slot: "trigger",
                          size: "small",
                          icon: "el-icon-plus",
                          type: "primary",
                          plain: ""
                        },
                        on: { click: _vm.openMaterialDialog },
                        slot: "trigger"
                      },
                      [_vm._v("从素材库选取")]
                    )
                  : _vm._e(),
                _vm.myType == 6 || _vm.myType == 7
                  ? _c(
                      "el-button",
                      {
                        staticClass: "upload-demo",
                        attrs: {
                          slot: "trigger",
                          size: "small",
                          icon: "el-icon-plus",
                          type: "primary",
                          plain: "",
                          disabled: !(
                            _vm.photoList.length == 0 &&
                            _vm.videoList.length == 0 &&
                            _vm.linkList.length == 0 &&
                            _vm.uploadFileList.length == 0 &&
                            _vm.appletList.length == 0
                          )
                        },
                        on: { click: _vm.openMaterialDialog },
                        slot: "trigger"
                      },
                      [_vm._v("从素材库选取")]
                    )
                  : _vm._e(),
                _vm.showApplet
                  ? _c(
                      "el-button",
                      {
                        staticClass: "upload-demo",
                        attrs: {
                          slot: "trigger",
                          size: "small",
                          icon: "el-icon-plus",
                          type: "primary",
                          plain: "",
                          disabled: _vm.handleBtnStatus("applet")
                        },
                        on: { click: _vm.openAppletPopup },
                        slot: "trigger"
                      },
                      [_vm._v("小程序页面")]
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        !_vm.onlyShow
          ? _c(
              "span",
              {
                staticStyle: {
                  color: "#9f9fb8",
                  display: "block",
                  "margin-top": "6px",
                  "margin-bottom": "10px"
                }
              },
              [_vm._v("温馨提示：点击以上按钮选择素材，只能选择其中某一种类型")]
            )
          : _vm._e(),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.photoList.length != 0,
                expression: "photoList.length != 0"
              }
            ],
            staticClass: "upload-photo-wrap"
          },
          _vm._l(_vm.photoList, function(item, index) {
            return _c("div", { key: index, staticClass: "photo-item" }, [
              _c(
                "div",
                { staticClass: "photo-wrap" },
                [
                  _c("el-image", {
                    staticClass: "photo",
                    attrs: { src: item.fileFullUrl, fit: "contain" },
                    on: {
                      click: function($event) {
                        return _vm.previewImage(item.fileFullUrl)
                      }
                    }
                  }),
                  !_vm.onlyShow
                    ? _c(
                        "div",
                        {
                          staticClass: "close-wrap",
                          on: {
                            click: function($event) {
                              return _vm.deletePhoto("photo", index)
                            }
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "el-icon-close close-icon"
                          })
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("span", { staticClass: "photo-name" }, [
                _vm._v(_vm._s(item.name))
              ])
            ])
          }),
          0
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.videoList.length != 0,
                expression: "videoList.length != 0"
              }
            ],
            staticClass: "upload-video-wrap"
          },
          [
            _c("video", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false"
                }
              ],
              key: _vm.menuKey,
              attrs: {
                width: "100%",
                controls: "controls",
                crossOrigin: "Anonymous",
                id: "upvideo"
              }
            }),
            _vm.videoList.length != 0
              ? _c("div", { staticClass: "item-wrap" }, [
                  _c(
                    "div",
                    {
                      staticClass: "item-left",
                      on: {
                        click: function($event) {
                          _vm.videoShow = true
                        }
                      }
                    },
                    [
                      _vm.imgsrc
                        ? _c("el-image", {
                            staticClass: "photo",
                            staticStyle: { height: "100%", width: "100%" },
                            attrs: { src: _vm.imgsrc }
                          })
                        : _vm._e(),
                      _c(
                        "span",
                        { staticClass: "start-wrap" },
                        [
                          _c("el-image", {
                            staticClass: "start-icon",
                            attrs: { src: _vm.defaulVideoUrl }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "item-right" }, [
                    _c("div", { staticClass: "video-name" }, [
                      _vm._v(_vm._s(_vm.videoList[0].name))
                    ])
                  ]),
                  !_vm.onlyShow
                    ? _c(
                        "div",
                        {
                          staticClass: "close-wrap",
                          on: {
                            click: function($event) {
                              return _vm.deletePhoto("video", 0)
                            }
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "el-icon-close close-icon"
                          })
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.uploadFileList.length != 0,
                expression: "uploadFileList.length != 0"
              }
            ],
            staticClass: "upload-file"
          },
          [
            _vm.uploadFileList &&
            _vm.uploadFileList[0] &&
            _vm.uploadFileList[0].resourceType
              ? _c(
                  "div",
                  { staticClass: "file-img" },
                  [
                    _c("el-image", {
                      staticClass: "start-icon",
                      attrs: {
                        src: _vm.handleUrl(_vm.uploadFileList[0].resourceType)
                      }
                    })
                  ],
                  1
                )
              : _c("i", { staticClass: "el-icon-document-remove" }),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.uploadFileList.length > 0
                    ? _vm.uploadFileList[0].name
                    : ""
                )
              )
            ]),
            !_vm.onlyShow
              ? _c(
                  "div",
                  {
                    staticClass: "point",
                    on: {
                      click: function($event) {
                        return _vm.deletePhoto("file", 0)
                      }
                    }
                  },
                  [_c("i", { staticClass: "el-icon-delete" })]
                )
              : _vm._e()
          ]
        ),
        _vm.appletList.length != 0
          ? _c(
              "div",
              { staticClass: "applet-wrap" },
              _vm._l(_vm.appletList, function(itemA, indexA) {
                return _c("div", { key: indexA, staticClass: "applet-item" }, [
                  _vm._m(0, true),
                  _c("div", { staticClass: "item-right" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(itemA.name))
                    ]),
                    _c("div", { staticClass: "content" }, [
                      _vm._v(" " + _vm._s(itemA.minUrl) + " ")
                    ])
                  ]),
                  !_vm.onlyShow
                    ? _c(
                        "div",
                        {
                          staticClass: "close-wrap",
                          on: {
                            click: function($event) {
                              return _vm.deletePhoto("applet", indexA)
                            }
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "el-icon-close close-icon"
                          })
                        ]
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          : _vm._e(),
        _vm.linkList.length != 0
          ? _c("div", { staticClass: "link-wrap" }, [
              _c("div", { staticClass: "link-item" }, [
                _c("div", { staticClass: "item-left" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.myFormLink.title))
                  ]),
                  _vm.myType != 3
                    ? _c("div", { staticClass: "content" }, [
                        _vm._v(" " + _vm._s(_vm.myFormLink.content) + " ")
                      ])
                    : _vm._e()
                ]),
                _c(
                  "div",
                  { staticClass: "item-right" },
                  [
                    _vm.myFormLink.pictureUrl
                      ? _c("el-image", {
                          staticClass: "photo",
                          attrs: { src: _vm.myFormLink.fileFullUrl },
                          on: {
                            click: function($event) {
                              return _vm.previewImage(
                                _vm.myFormLink.fileFullUrl
                              )
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                !_vm.onlyShow
                  ? _c(
                      "div",
                      {
                        staticClass: "close-wrap",
                        on: {
                          click: function($event) {
                            return _vm.deletePhoto("link", 0)
                          }
                        }
                      },
                      [_c("span", { staticClass: "el-icon-close close-icon" })]
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm.productList.length != 0
          ? _c("div", { staticClass: "link-wrap" }, [
              _c("div", { staticClass: "link-item" }, [
                _c("div", { staticClass: "item-left" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.productDetail.title))
                  ]),
                  _c("div", { staticClass: "content" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.productDetail.linkType == "goods",
                            expression: "productDetail.linkType == 'goods'"
                          }
                        ]
                      },
                      [_vm._v("商城价:￥" + _vm._s(_vm.productDetail.price))]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.productDetail.linkType == "coupon",
                            expression: "productDetail.linkType == 'coupon'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          "满" +
                            _vm._s(_vm.productDetail.couEnableprice) +
                            "减" +
                            _vm._s(_vm.productDetail.price)
                        )
                      ]
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "item-right" },
                  [
                    _vm.productDetail.linkType == "goods"
                      ? _c("el-image", {
                          staticClass: "photo",
                          attrs: { src: _vm.productDetail.pictureUrl },
                          on: {
                            click: function($event) {
                              return _vm.previewImage(
                                _vm.productDetail.pictureUrl
                              )
                            }
                          }
                        })
                      : _c("el-image", {
                          staticClass: "photo",
                          attrs: { src: require("@/assets/img/ticket.jpg") },
                          on: {
                            click: function($event) {
                              _vm.previewImage(
                                require("@/assets/img/ticket.jpg")
                              )
                            }
                          }
                        })
                  ],
                  1
                ),
                !_vm.onlyShow
                  ? _c(
                      "div",
                      {
                        staticClass: "close-wrap",
                        on: {
                          click: function($event) {
                            return _vm.deletePhoto("product", 0)
                          }
                        }
                      },
                      [_c("span", { staticClass: "el-icon-close close-icon" })]
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "video-dialog",
          staticStyle: { "margin-top": "0vh" },
          attrs: {
            visible: _vm.videoShow,
            width: "400px",
            "close-on-click-modal": "",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.videoShow = $event
            }
          }
        },
        [
          _vm.videoList.length != 0
            ? _c(
                "video",
                {
                  attrs: { width: "100%", height: "auto", controls: "controls" }
                },
                [
                  _c("source", {
                    attrs: {
                      src: _vm.videoList[0].fileFullUrl,
                      type: "video/mp4"
                    }
                  })
                ]
              )
            : _vm._e()
        ]
      ),
      _c("el-image", {
        ref: "myImg",
        staticClass: "my-preview-image",
        attrs: { src: _vm.previewUrl, "preview-src-list": _vm.previewSrcList }
      }),
      _c("canvas", {
        staticStyle: { display: "none" },
        attrs: { id: "mycanvas" }
      }),
      _c("NewLink", { ref: "newLink", on: { comfirm: _vm.linkComfirm } }),
      _vm.showAppletPopup
        ? _c("appletPopup", {
            ref: "appletPopupRef",
            on: { comfirm: _vm.appletComfirm, close: _vm.closeApp }
          })
        : _vm._e(),
      _c("SelectMaterialDialog", {
        ref: "selectMaterialDialog",
        attrs: { myType: _vm.myType },
        on: {
          confirmSelectMateria: _vm.confirmSelectMateria,
          previewTableImage: _vm.previewImage
        }
      }),
      _c("WelcomeTempDia", {
        attrs: { welcomeDislogVisible: _vm.welcomeDislogVisible },
        on: {
          welcomeCloseHandle: _vm.welcomeCloseHandle,
          welcomeConfirmHandle: _vm.welcomeConfirmHandle
        }
      }),
      _c("ProductVoucher", {
        ref: "product",
        attrs: { currentSysm: _vm.currentSysm },
        on: { handleSubmit: _vm.getProductDetail }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-left" }, [
      _c("img", {
        staticClass: "img",
        attrs: { src: require("@/assets/img/applet.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }